import { Tooltip } from '@insurancemenu/imenu-components-lib';
import { TooltipWrapperStyled } from '@insurancemenu/imenu-components-lib/dist/components/Tooltip/styles';
import styled from 'styled-components';

// Displays three dots (...) and hides text if it is wider than the container.
export const ShortProductLinesTitleStyled = styled.p`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 90%;
  margin: 0;
`;

export const TooltipContainerStyled = styled.div`
  /* Ensure block has min-height when it contains no product lines */
  min-height: 2.2rem;

  /* Target the Tooltip's root from the lib using styled-components component selector.
     Will not work without it. */
  & > ${TooltipWrapperStyled} {
    display: block;
    width: unset;
    height: unset;
  }
`;

/* Position was manually changed due to an unusual case: the list of product lines
    is displayed but covered by the tooltip. It will not be shown otherwise. */
export const TooltipStyled = styled(Tooltip)`
  left: 100%;
  width: 30rem;
  white-space: wrap;
`;
